export const styles = {
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    overflow: 'hidden',
  },
  contentMediaContent: {
    display: 'flex',
    gap: '22px',
  },
  createdAtTypo: {
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '150%',
    fontWeight: 400,
    color: '#6E707A',
    textAlign: 'right',
  },
};
